<template>
    <div id="ap">
        <a-layout>
            <div class="content-header">
                <a-affix :offset-top="0" style="width: 100%;">
                    <a-row type="flex" justify="space-between">
                        <a-col span="12">
                            <a-space>
                                <a-input v-model="param.keyword" allowClear search @pressEnter="doRefresh"
                                    @on-clear="doRefresh" placeholder="关键词查询"></a-input>
                                <a-button type="primary" @click="doRefresh" icon="search">查询</a-button>
                            </a-space>
                        </a-col>
                        <a-col span="12">
                            <common-page-btn></common-page-btn>
                        </a-col>
                        <!-- <a-col span="12">
                            <a-row type="flex" align="middle" justify="end" :gutter="3">
                                <a-col span="6">
                                    <a-input v-model="param.keyword" allowClear search @pressEnter="doRefresh"
                                        @on-clear="doRefresh" placeholder="关键词查询"></a-input>
                                </a-col>
                            </a-row>
                        </a-col> -->
                    </a-row>
                </a-affix>
            </div>
        </a-layout>

        <a-layout>
            <a-layout-content>
                <a-table :defaultExpandAllRows="true" :scroll="{ x: '100%' }" :pagination="false" :indentSize="25"
                    :style="{ background: '#FFF' }" size="small" row-key="id" border :columns="keys" ref="list"
                    :loading="loading" :data-source="data.records">
                    <template slot-scope="row" slot="recommend">
                        <a-switch v-model="row.isRecommend" size="small" @change="setRecommend(row)"></a-switch>
                    </template>
                    <template slot-scope="row" slot="status">
                        <a-tag color="red" v-if="row.state == 0">待审核</a-tag>
                        <a-tag color="green" v-else>已审核</a-tag>
                    </template>
                    <template slot-scope="row" slot="action">
                        <a-button-group shape="circle" size="small">
                            <a-tooltip v-has="'store:change:audit'" title="审核">
                                <a-button type="primary" :disabled="row.state != 0"
                                    @click="showModal(row)">审核</a-button>
                            </a-tooltip>
                        </a-button-group>
                    </template>
                </a-table>
            </a-layout-content>
        </a-layout>
        <a-row>
            <a-col span="12" offset="6" style="text-align: center; padding: 20px 0;">
                <a-pagination :defaultPageSize="param.limit" :total="data.total" @change="getNext"
                    @showSizeChange="setLimit" :current="data.current" />
            </a-col>
        </a-row>
        <div>
            <a-modal title="资料审核" cancelText="取消" okText="确认审核" :visible="visible" :confirm-loading="confirmLoading"
                @ok="handleOk" @cancel="handleCancel">
                <a-form-model ref="form" :model="formData" v-if="formData != null">
                    <a-row :gutter="15">
                        <a-col span="8">
                            <a-form-model-item label="审核结果" prop="result" label-position="top"
                                :rules="[{ required: true, message: '请选择审核结果' }]">
                                <a-select v-model="formData.result" placeholder="请选择审核结果">
                                    <a-select-option :value="1">审核通过</a-select-option>
                                    <a-select-option :value="0">审核驳回</a-select-option>
                                </a-select>
                            </a-form-model-item>
                        </a-col>
                        <a-col span="16">
                            <a-form-model-item label="驳回原因" label-position="top"
                                :rules="{ required: formData.result == 0, message: '请填写驳回原因' }">
                                <a-input v-model="formData.reason" :disabled="formData.result != 0"
                                    placeholder="请输入驳回原因"></a-input>
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="15">
                        <a-col span="24" v-if="detail.thumb && detail.thumb != ''">
                            <a-form-model-item label="图片" label-position="top">
                                <img :src="detail.thumb" width="100px" height="100px" />
                            </a-form-model-item>
                        </a-col>
                        <a-col span="24">
                            <a-form-model-item label="简介信息" label-position="top">
                                {{ detail.description }}
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                </a-form-model>
            </a-modal>
        </div>
        <a-back-top />

    </div>
</template>

<script>
import apiUtil from "@/common/apiUtil";
import utils from '@/common/utils';
export default {
    components: {},
    data() {
        return {
            confirmLoading: false,
            visible: false,
            loading: false,
            isExamine: true,
            cause: '',
            storeId: null,
            status: '',
            data: [],
            param: {
                page: 1,
                limit: 20,
                keyword: '',
                organId: apiUtil.getDefaultOrganId(),
                areaId: '',
                cateId: ''
            },
            organList: apiUtil.getOrganList(),
            keys: [
                { title: '商户名称', dataIndex: 'storeName', width: 200, ellipsis: true },
                { title: '简介', dataIndex: 'description', align: 'left', ellipsis: true },
                { title: '提交时间', dataIndex: 'createTime', width: 180, ellipsis: true, tooltips: true },
                { title: '提交人', dataIndex: 'userName', width: 120, ellipsis: true },
                { title: '状态', scopedSlots: { customRender: 'status' }, width: 100, ellipsis: true },
                { title: '操作', scopedSlots: { customRender: 'action' }, align: 'center', width: 200 }
            ],
            detail: null,
            formData: null
        };
    },
    created() {
        this.getList();
    },
    methods: {
        // 获取数据
        getList() {
            this.loading = true;
            this.http
                .get('/platform/store/change', this.param)
                .then(ret => {
                    this.data = ret.data;
                    this.loading = false;
                })
                .catch(err => {
                    this.loading = false;
                });
        },
        handleChange(e) {
            console.log(e);
        },
        // 点击审批
        showModal(e) {
            this.detail = JSON.parse(JSON.stringify(e));
            this.formData = { changeId: e.id, result: 1, reason: '' };
            this.visible = true;
        },
        // 确认审核
        handleOk(e) {

            this.http
                .post('/platform/store/change/audit', this.formData)
                .then(ret => {
                    if (ret.code == 200) {
                        this.utils.success('操作成功！').then(() => {
                            this.getList();
                        });
                    }
                    this.visible = false;
                })
                .catch(err => {
                    this.visible = false;
                });
        },
        doRefresh() {
            this.param.page = 1;
            this.getList();
        },
        // 取消审批
        handleCancel(e) {
            this.visible = false;
        },
        //设置每页的显示条数
        setLimit(current, limit) {
            this.param.page = 1;
            this.param.limit = limit;
        },
        //页码切换
        getNext(page) {
            this.param.page = page;
            this.getList();
        }
    }
};
</script>

<style scoped></style>
